var map = {
	"./HDicon.png": 20592,
	"./IE11-icon.png": 589,
	"./SDicon.png": 27709,
	"./SatelliteAltOutlined.png": 46909,
	"./SignalCellularAltRounded.png": 99913,
	"./SupportedBrowsers_icons.png": 81377,
	"./WIFI.png": 79608,
	"./agent-guidance/android/app-share-user-1.png": 97145,
	"./agent-guidance/android/camera-allow-1.png": 93077,
	"./agent-guidance/android/camera-allow-2.png": 7326,
	"./agent-guidance/android/camera-reject-1.png": 5841,
	"./agent-guidance/android/email-1.png": 16730,
	"./agent-guidance/android/email-2.png": 92977,
	"./agent-guidance/android/screen-mirroring-waiting-1.png": 54118,
	"./agent-guidance/android/screen-mirroring-waiting-2.png": 37885,
	"./agent-guidance/android/screen-mirroring-waiting-3.png": 404,
	"./agent-guidance/android/screen-share-1.png": 71646,
	"./agent-guidance/android/screen-share-user-1.png": 2484,
	"./agent-guidance/android/sms-1.png": 64117,
	"./agent-guidance/android/sms-waiting-1.png": 70999,
	"./agent-guidance/android/sms-wifi-analysis-1.png": 24984,
	"./agent-guidance/android/speaker-1.png": 53889,
	"./agent-guidance/android/terms-allow-1.png": 37447,
	"./agent-guidance/android/terms-reject-1.png": 15779,
	"./agent-guidance/android/video-application-1.png": 76890,
	"./agent-guidance/android/video-application-2.png": 1553,
	"./agent-guidance/android/whatsapp-1.png": 3782,
	"./agent-guidance/android/whatsapp-waiting-1.png": 10976,
	"./agent-guidance/android/wifi-1.png": 72567,
	"./agent-guidance/android/wifi-2.png": 14460,
	"./agent-guidance/android/wifi-3.png": 97349,
	"./agent-guidance/android/wifi-analysis-waiting-1.png": 6190,
	"./agent-guidance/android/wifi-analysis-waiting-2.png": 24965,
	"./agent-guidance/android/wifi-analysis-waiting-3.png": 91100,
	"./agent-guidance/common/chrome/desktop-sharing-type.png": 12029,
	"./agent-guidance/common/desktop-sharing-1.png": 67377,
	"./agent-guidance/common/desktop-sharing-2.png": 7482,
	"./agent-guidance/common/desktop-sharing-3.png": 97315,
	"./agent-guidance/common/firefox/desktop-sharing-type-1.png": 67674,
	"./agent-guidance/common/firefox/desktop-sharing-type-2.png": 97841,
	"./agent-guidance/common/safari/desktop-sharing-type.png": 4783,
	"./agent-guidance/ios/app-share-user-1.png": 75583,
	"./agent-guidance/ios/camera-allow-1.png": 20275,
	"./agent-guidance/ios/camera-reject-1.png": 36287,
	"./agent-guidance/ios/email-1.png": 71436,
	"./agent-guidance/ios/email-2.png": 90439,
	"./agent-guidance/ios/go-to-application-1.png": 11105,
	"./agent-guidance/ios/go-to-application-i.png": 57449,
	"./agent-guidance/ios/screen-mirroring-waiting-1.png": 87920,
	"./agent-guidance/ios/screen-mirroring-waiting-2.png": 59211,
	"./agent-guidance/ios/screen-mirroring-waiting-3.png": 38082,
	"./agent-guidance/ios/screen-mirroring-waiting-4.png": 25981,
	"./agent-guidance/ios/screen-mirroring-waiting-5.png": 9300,
	"./agent-guidance/ios/screen-share-1.png": 75756,
	"./agent-guidance/ios/screen-share-2.png": 95815,
	"./agent-guidance/ios/screen-share-user-1.png": 67446,
	"./agent-guidance/ios/sms-1.png": 55279,
	"./agent-guidance/ios/sms-waiting-1.png": 95085,
	"./agent-guidance/ios/sms-wifi-analysis-1.png": 79446,
	"./agent-guidance/ios/speaker-1.png": 2271,
	"./agent-guidance/ios/terms-allow-1.png": 20993,
	"./agent-guidance/ios/terms-reject-1.png": 23613,
	"./agent-guidance/ios/video-application-1.png": 69936,
	"./agent-guidance/ios/video-application-2.png": 39787,
	"./agent-guidance/ios/whatsapp-1.png": 34540,
	"./agent-guidance/ios/whatsapp-waiting-1.png": 59354,
	"./agent-guidance/ios/wifi-1.png": 14901,
	"./agent-guidance/ios/wifi-2.png": 29150,
	"./agent-guidance/ios/wifi-3.png": 16839,
	"./agent-guidance/ios/wifi-analysis-waiting-1.png": 94224,
	"./agent-guidance/ios/wifi-analysis-waiting-2.png": 8043,
	"./agent-guidance/ios/wifi-analysis-waiting-3.png": 17538,
	"./agent-guidance/ios/wifi-analysis-waiting-4.png": 79261,
	"./agent-guidance/ios/wifi-analysis-waiting-5.png": 58132,
	"./analyze/back.png": 51429,
	"./analyze/close.png": 14882,
	"./analyze/logo.png": 74557,
	"./analyze/minimize.png": 93732,
	"./analyze/restore.png": 45936,
	"./analyze/send.png": 86838,
	"./android-helper.png": 70225,
	"./app-not-install-old.png": 49232,
	"./app-not-install.png": 13000,
	"./apple-helper.png": 35830,
	"./attention.png": 69805,
	"./audio-off.png": 56865,
	"./audio-on.png": 18303,
	"./bubble.png": 6757,
	"./cancel.png": 55105,
	"./chevron-left-blue.png": 349,
	"./chevron-right-blue.png": 7742,
	"./chevron-right-orange.png": 50688,
	"./chrome-icon.png": 20975,
	"./chrome-web-icon.png": 33232,
	"./classification-mocks/15.png": 37668,
	"./classification-mocks/16.png": 74527,
	"./classification-mocks/17.png": 77590,
	"./close-session.png": 75312,
	"./close.png": 83971,
	"./collapse.png": 22538,
	"./color.png": 39162,
	"./connected-mode.png": 69584,
	"./cursor-analyze-ie.cur": 20639,
	"./cursor-analyze.png": 15278,
	"./cursor-select.cur": 44672,
	"./cursor-select.png": 78480,
	"./cursor-snap.cur": 87076,
	"./cursor-snap.png": 47520,
	"./directory.png": 24774,
	"./dots-spinner-white.gif": 508,
	"./dots-spinner.gif": 15052,
	"./edge-icon.png": 8516,
	"./empty-gallery-mini.png": 39121,
	"./empty-gallery-placeholder.png": 74545,
	"./error-background.png": 24492,
	"./expand.png": 13831,
	"./failed-icon.png": 67556,
	"./failed-image-placeholder.png": 39928,
	"./favicon-16x16.png": 98190,
	"./favicon-32x32.png": 39426,
	"./favicon-96x96.png": 98558,
	"./ff-icon.png": 86681,
	"./file.png": 39869,
	"./firefox-icon.png": 37608,
	"./flashlight-off-guidance.png": 15110,
	"./flashlight-on-guidance.png": 58956,
	"./full-signal.png": 98155,
	"./green-light-icon.png": 17923,
	"./hide-password-eye.png": 52973,
	"./icon-annotate.png": 82779,
	"./icon-annotation.png": 11580,
	"./icon-arrow-down.png": 91459,
	"./icon-arrow-right.png": 16913,
	"./icon-arrow.png": 56096,
	"./icon-blue-techsee.png": 64473,
	"./icon-camera-large-selected.png": 12060,
	"./icon-camera-large.png": 66960,
	"./icon-camera-selected.png": 65958,
	"./icon-camera.png": 87622,
	"./icon-circle.png": 34343,
	"./icon-connected-with.png": 48405,
	"./icon-connecting-to.png": 69391,
	"./icon-customer-mode-application_sharing.png": 23583,
	"./icon-customer-mode-images.png": 27332,
	"./icon-customer-mode-one_click.png": 16073,
	"./icon-customer-mode-screen.png": 29498,
	"./icon-customer-mode-video.png": 62973,
	"./icon-free-line.png": 96122,
	"./icon-hand.png": 50816,
	"./icon-location-available.png": 57140,
	"./icon-location-unavailable.png": 40723,
	"./icon-meeting-ended.png": 22843,
	"./icon-mute-golden.png": 74960,
	"./icon-new-email-selected.png": 50018,
	"./icon-new-email.png": 3506,
	"./icon-new-sms-selected.png": 19819,
	"./icon-new-sms.png": 64409,
	"./icon-new-whatsapp-selected.png": 13938,
	"./icon-new-whatsapp.png": 97826,
	"./icon-orange-email.png": 67246,
	"./icon-orange-sms.png": 94453,
	"./icon-orange-techsee.png": 81903,
	"./icon-orange-whatsapp.png": 990,
	"./icon-phone-medium.png": 27015,
	"./icon-phone-small.png": 29901,
	"./icon-rectangle.png": 31996,
	"./icon-report-selected.png": 94687,
	"./icon-report.png": 55917,
	"./icon-rotate-left.png": 77322,
	"./icon-rotate-right.png": 28743,
	"./icon-screenshot.png": 30639,
	"./icon-search.png": 48039,
	"./icon-settings-selected.png": 95904,
	"./icon-settings.png": 36660,
	"./icon-text-balloon.png": 32720,
	"./icon-union.png": 8438,
	"./icon-unmute-golden.png": 60887,
	"./icon-video-large-selected.png": 66920,
	"./icon-video-large.png": 27052,
	"./icon-zoom.png": 92890,
	"./icon_close.png": 74605,
	"./icon_draw.png": 76387,
	"./icon_eye.png": 91982,
	"./icon_hand.png": 89522,
	"./icon_url.png": 68902,
	"./idle-mode.png": 40001,
	"./info.png": 21643,
	"./insights-icon.png": 21332,
	"./instruction-icon.png": 35389,
	"./invite-icon.png": 89800,
	"./invite-no-sessions.png": 88754,
	"./ios-network-scan.png": 18091,
	"./login-icon.png": 56828,
	"./logo-android.png": 89592,
	"./logo-apple.png": 9169,
	"./logo-email.png": 59009,
	"./logo-guest.png": 65489,
	"./mini-dashboard/arrow.png": 61391,
	"./mini-dashboard/celular.png": 49286,
	"./mini-dashboard/circle.png": 81094,
	"./mini-dashboard/close.png": 85692,
	"./mini-dashboard/connected.png": 27493,
	"./mini-dashboard/disconnected.png": 743,
	"./mini-dashboard/drag.png": 28100,
	"./mini-dashboard/end-meeting.png": 62343,
	"./mini-dashboard/hand.png": 34729,
	"./mini-dashboard/location.png": 54443,
	"./mini-dashboard/muted.png": 50761,
	"./mini-dashboard/network-connected.png": 55860,
	"./mini-dashboard/no-images.png": 54168,
	"./mini-dashboard/observer.png": 68536,
	"./mini-dashboard/offline.png": 68601,
	"./mini-dashboard/pen.png": 52381,
	"./mini-dashboard/record-start.png": 38626,
	"./mini-dashboard/record-stop.png": 39504,
	"./mini-dashboard/recording-dot.png": 21323,
	"./mini-dashboard/rectangle.png": 34927,
	"./mini-dashboard/scan.png": 53713,
	"./mini-dashboard/scanned.png": 53928,
	"./mini-dashboard/screensharing.png": 21524,
	"./mini-dashboard/send.png": 59656,
	"./mini-dashboard/snapshot.png": 33982,
	"./mini-dashboard/switch-camera.png": 50764,
	"./mini-dashboard/switch-video.png": 25316,
	"./mini-dashboard/text.png": 96059,
	"./mini-dashboard/undo.png": 91632,
	"./mini-dashboard/unmuted.png": 6630,
	"./mini-dashboard/video-small-white.png": 2487,
	"./mini-dashboard/waiting icon.png": 45818,
	"./mini-dashboard/wifi.png": 66549,
	"./mobile-dashboard/arrow.png": 91768,
	"./mobile-dashboard/audio-off.png": 18765,
	"./mobile-dashboard/audio-on.png": 79675,
	"./mobile-dashboard/circle.png": 7839,
	"./mobile-dashboard/clear.png": 69276,
	"./mobile-dashboard/drag.png": 19605,
	"./mobile-dashboard/end-meeting.png": 92280,
	"./mobile-dashboard/gear.png": 71490,
	"./mobile-dashboard/hand.png": 8920,
	"./mobile-dashboard/live-video.png": 33071,
	"./mobile-dashboard/location-available-icon.png": 62688,
	"./mobile-dashboard/location-unavailable-icon.png": 70937,
	"./mobile-dashboard/location.png": 87185,
	"./mobile-dashboard/message.png": 40990,
	"./mobile-dashboard/mic-mute.png": 91074,
	"./mobile-dashboard/mic-unmute.png": 4152,
	"./mobile-dashboard/mute.png": 22320,
	"./mobile-dashboard/observer.png": 50189,
	"./mobile-dashboard/pen.png": 4186,
	"./mobile-dashboard/rectangle.png": 92868,
	"./mobile-dashboard/screenshot-blue.png": 3294,
	"./mobile-dashboard/screenshot.png": 9143,
	"./mobile-dashboard/send.png": 53545,
	"./mobile-dashboard/speaker-loud-circle.png": 47306,
	"./mobile-dashboard/speaker-mute-circle.png": 3631,
	"./mobile-dashboard/switch-camera.png": 51903,
	"./mobile-dashboard/switch-video.png": 6729,
	"./mobile-dashboard/text.png": 87006,
	"./mobile-dashboard/undo.png": 52737,
	"./mobile-dashboard/unmute.png": 74765,
	"./mobile-dashboard/video-small-white.png": 632,
	"./mouse-share-blue.png": 59407,
	"./new-interface-assets/bulk-images/ic_check.png": 96469,
	"./new-interface-assets/bulk-images/ic_check_all.png": 84365,
	"./new-interface-assets/bulk-images/ic_check_all_dis.png": 25784,
	"./new-interface-assets/bulk-images/ic_check_all_mo.png": 28858,
	"./new-interface-assets/bulk-images/ic_check_all_sel.png": 34796,
	"./new-interface-assets/bulk-images/ic_check_dis.png": 24800,
	"./new-interface-assets/bulk-images/ic_check_mo.png": 67202,
	"./new-interface-assets/bulk-images/ic_check_sel.png": 45492,
	"./new-interface-assets/bulk-images/ic_copy_clipboard.png": 73737,
	"./new-interface-assets/bulk-images/ic_copy_clipboard_dis.png": 63860,
	"./new-interface-assets/bulk-images/ic_copy_clipboard_mo.png": 17334,
	"./new-interface-assets/bulk-images/ic_copy_clipboard_sel.png": 62976,
	"./new-interface-assets/bulk-images/ic_download.png": 61405,
	"./new-interface-assets/bulk-images/ic_downloadAndEmail.png": 47000,
	"./new-interface-assets/bulk-images/ic_downloadAndEmail_dis.png": 86497,
	"./new-interface-assets/bulk-images/ic_downloadAndEmail_mo.png": 14993,
	"./new-interface-assets/bulk-images/ic_downloadAndEmail_sel.png": 99725,
	"./new-interface-assets/bulk-images/ic_download_dis.png": 57896,
	"./new-interface-assets/bulk-images/ic_download_mo.png": 26762,
	"./new-interface-assets/bulk-images/ic_download_sel.png": 41980,
	"./new-interface-assets/bulk-images/ic_email.png": 8993,
	"./new-interface-assets/bulk-images/ic_email_dis.png": 8140,
	"./new-interface-assets/bulk-images/ic_email_mo.png": 88014,
	"./new-interface-assets/bulk-images/ic_email_sel.png": 15896,
	"./new-interface-assets/bulk-images/ic_send.png": 74835,
	"./new-interface-assets/bulk-images/ic_send_dis.png": 60502,
	"./new-interface-assets/bulk-images/ic_send_mo.png": 62428,
	"./new-interface-assets/bulk-images/ic_send_sel.png": 64194,
	"./new-interface-assets/camera.png": 39263,
	"./new-interface-assets/cancel.png": 36116,
	"./new-interface-assets/capture-scan.png": 75486,
	"./new-interface-assets/close-scanning.png": 7606,
	"./new-interface-assets/close-session.png": 46995,
	"./new-interface-assets/collapsed.png": 92927,
	"./new-interface-assets/color.png": 64725,
	"./new-interface-assets/copy-to-clipboard-dis.png": 14825,
	"./new-interface-assets/copy-to-clipboard.png": 36218,
	"./new-interface-assets/download-dis.png": 81949,
	"./new-interface-assets/download.png": 95982,
	"./new-interface-assets/expanded.png": 80837,
	"./new-interface-assets/full-signal.png": 87956,
	"./new-interface-assets/icon-analyze-selected.png": 77786,
	"./new-interface-assets/icon-analyze.png": 21210,
	"./new-interface-assets/icon-arrow-selected.png": 52475,
	"./new-interface-assets/icon-arrow.png": 6217,
	"./new-interface-assets/icon-circle-selected.png": 72372,
	"./new-interface-assets/icon-circle.png": 53560,
	"./new-interface-assets/icon-customer-mode-application_sharing.png": 37630,
	"./new-interface-assets/icon-customer-mode-co_browsing.png": 18955,
	"./new-interface-assets/icon-customer-mode-images.png": 39051,
	"./new-interface-assets/icon-customer-mode-one_click.png": 35228,
	"./new-interface-assets/icon-customer-mode-screen.png": 63989,
	"./new-interface-assets/icon-customer-mode-video.png": 88884,
	"./new-interface-assets/icon-free-line-selected.png": 75313,
	"./new-interface-assets/icon-free-line.png": 16451,
	"./new-interface-assets/icon-hand-selected.png": 49105,
	"./new-interface-assets/icon-hand.png": 60163,
	"./new-interface-assets/icon-rectangle-selected.png": 16355,
	"./new-interface-assets/icon-rectangle.png": 61761,
	"./new-interface-assets/icon-rotate-left.png": 2115,
	"./new-interface-assets/icon-rotate-right.png": 96716,
	"./new-interface-assets/icon-screenshot-selected.png": 94692,
	"./new-interface-assets/icon-screenshot.png": 7464,
	"./new-interface-assets/icon-text-balloon-selected.png": 19241,
	"./new-interface-assets/icon-text-balloon.png": 16075,
	"./new-interface-assets/icon-zoom.png": 18005,
	"./new-interface-assets/mouse-share-blue-selected.png": 18142,
	"./new-interface-assets/mouse-share-blue.png": 33614,
	"./new-interface-assets/new-scan.png": 38502,
	"./new-interface-assets/no-signal.png": 83518,
	"./new-interface-assets/pause-dashboard.png": 86141,
	"./new-interface-assets/play-dashboard.png": 64355,
	"./new-interface-assets/save-gallery.png": 57048,
	"./new-interface-assets/scan-selected.png": 24207,
	"./new-interface-assets/scan.png": 70461,
	"./new-interface-assets/search-by-tag.png": 13933,
	"./new-interface-assets/select-all.png": 73488,
	"./new-interface-assets/send-email-dis.png": 55848,
	"./new-interface-assets/send-email.png": 66691,
	"./new-interface-assets/send-gallery.png": 42761,
	"./new-interface-assets/share-dis.png": 46582,
	"./new-interface-assets/share-gallery.png": 22860,
	"./new-interface-assets/share.png": 42285,
	"./new-interface-assets/stretched-video/icon-recognize.png": 9255,
	"./new-interface-assets/stretched-video/pause-ds-customer-techsee.png": 71432,
	"./new-interface-assets/stretched-video/pause-ds-customer.png": 70650,
	"./new-interface-assets/stretched-video/paused-by-customer-chat.png": 74475,
	"./new-interface-assets/stretched-video/paused-by-customer-ds.png": 3702,
	"./new-interface-assets/stretched-video/paused-by-customer-live.png": 49943,
	"./new-interface-assets/stretched-video/paused-by-customer-screen.png": 7221,
	"./new-interface-assets/stretched-video/scan-blue-43x43.png": 51474,
	"./new-interface-assets/stretched-video/scan.png": 46752,
	"./new-interface-assets/stretched-video/snapshot-blue-43x43.png": 187,
	"./new-interface-assets/stretched-video/snapshot.png": 7519,
	"./new-interface-assets/tag-blue-selected.png": 67953,
	"./new-interface-assets/tag-blue.png": 50339,
	"./new-interface-assets/undo.png": 26980,
	"./new-interface-assets/unselected-icon-mode-application_sharing.png": 42806,
	"./new-interface-assets/unselected-icon-mode-co_browsing.png": 55523,
	"./new-interface-assets/unselected-icon-mode-images.png": 26403,
	"./new-interface-assets/unselected-icon-mode-one_click.png": 22660,
	"./new-interface-assets/unselected-icon-mode-screen.png": 98397,
	"./new-interface-assets/unselected-icon-mode-video.png": 67260,
	"./new-interface-assets/upload-image.png": 3081,
	"./new-logo-text-right.png": 93936,
	"./new-logo-white.png": 68945,
	"./new-logo.png": 85477,
	"./new-pointer-desktop.cur": 51318,
	"./new-pointer-desktop.png": 95050,
	"./new-pointer-disabled.png": 60,
	"./no-signal.png": 47573,
	"./offline-editor-exit.png": 15573,
	"./offline-pool.png": 89843,
	"./orange-light-icon.png": 15190,
	"./password-eye.png": 17332,
	"./pause-video-avatar.png": 23049,
	"./pause-video.png": 65155,
	"./pause_mode.png": 64815,
	"./play-video.png": 14995,
	"./pointer.cur": 62924,
	"./pointer.png": 13180,
	"./react-assets/customer-left.png": 35945,
	"./react-assets/robot.png": 20443,
	"./react-assets/techsee.png": 14802,
	"./red-badge.png": 33776,
	"./red-light-icon.png": 87895,
	"./redirect-store_android1.png": 59754,
	"./redirect-store_android2.png": 17185,
	"./redirect-store_android3.png": 79704,
	"./redirect-store_ios1.png": 90416,
	"./redirect-store_ios2.png": 4235,
	"./redirect-store_ios3.png": 13730,
	"./remote-control-icon.svg": 3654,
	"./sad-smile-icon.png": 97788,
	"./safari-icon.png": 8765,
	"./safari-web-icon.png": 66478,
	"./save-gallery.png": 19141,
	"./scan.png": 30116,
	"./searchNoFound.png": 40216,
	"./send-gallery.png": 82276,
	"./sessionEnded.png": 93735,
	"./sf-logo.png": 74442,
	"./sharp-arrow-right.png": 94662,
	"./signal-green-underline.png": 53058,
	"./signal-red-underline.png": 13842,
	"./smile-icon.png": 27329,
	"./speaker-loud-golden.png": 95733,
	"./speaker-loud-white.png": 24147,
	"./speaker-mute-golden.png": 80200,
	"./speaker-mute-white.png": 93632,
	"./speedtest-guidance.png": 22199,
	"./spinner.gif": 32751,
	"./status-disabled.png": 71112,
	"./success-icon.png": 10282,
	"./success.png": 70438,
	"./switch-mode-photo.png": 59112,
	"./tag-blue.png": 22134,
	"./tag-white.png": 46351,
	"./tech-sup-logo.png": 1726,
	"./techsee-logo.png": 75832,
	"./techsee_logo.png": 29390,
	"./techsee_logo.svg": 86019,
	"./tip-left.png": 62524,
	"./tip-right.png": 84857,
	"./unavailableImage.png": 39858,
	"./undo.png": 91589,
	"./unsuccess.png": 43141,
	"./unsupported-br.png": 15345,
	"./unsupported-device.png": 15351,
	"./uploading-photo/android/image1(Android).png": 97474,
	"./uploading-photo/android/image2(Android).png": 62299,
	"./uploading-photo/android/image3(Android).png": 60792,
	"./uploading-photo/android/image4(Android).png": 74185,
	"./uploading-photo/ios/image1(iOS).png": 222,
	"./uploading-photo/ios/image2(iOS).png": 54179,
	"./uploading-photo/ios/image3(iOS).png": 3052,
	"./uploading-photo/ios/image4(iOS).png": 44817,
	"./video-preloader-black.gif": 1170,
	"./video-preloader.gif": 18876,
	"./video-thumbnail.png": 55753,
	"./video.png": 90694,
	"./whatsapp-icon.png": 95051,
	"./whatsapp-invite-button.png": 31326,
	"./wifi-check.png": 64583,
	"./wifi/WifiFindOutlined.png": 38925,
	"./wizard/android/camera-approval.png": 34952,
	"./wizard/android/one-click-guidance-audio.png": 79872,
	"./wizard/android/one-click-guidance.png": 4637,
	"./wizard/android/pre-camera-approval.png": 40652,
	"./wizard/android/sms-approve.png": 8796,
	"./wizard/android/sms-notification.png": 44082,
	"./wizard/android/sms-tap.png": 87216,
	"./wizard/android/terms-approval.png": 38052,
	"./wizard/generic/android.png": 53208,
	"./wizard/generic/attention_icon.png": 44083,
	"./wizard/generic/iphone.png": 53282,
	"./wizard/iphone/camera-approval.png": 62666,
	"./wizard/iphone/one-click-guidance-audio.png": 68918,
	"./wizard/iphone/one-click-guidance.png": 14031,
	"./wizard/iphone/pre-camera-approval.png": 81802,
	"./wizard/iphone/sms-notification.png": 64628,
	"./wizard/iphone/sms-tap.png": 73462,
	"./wizard/iphone/terms-approval.png": 21882,
	"./www.png": 75014,
	"./yellow-light-icon.png": 52104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59877;